import { useState } from "react";
import axios from "axios";
import { ArrowUpRight, X } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ConsultationModal = ({ lang, open, onClose, ctaLabel }) => {
  const [form, setForm] = useState({ name: "", email: "", villa_location: "" });
  const [sending, setSending] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await axios.post(`${API}/consultations`, { ...form, language: lang });
      onClose();
      setForm({ name: "", email: "", villa_location: "" });
      toast.success(lang === "en" ? "Thank you. We’ll be in touch shortly." : "Terima kasih. Kami akan segera menghubungi Anda.");
    } catch (err) {
      toast.error(lang === "en" ? "Something went wrong. Please try again." : "Terjadi kesalahan. Silakan coba lagi.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose} data-testid="consultation-modal-backdrop">
      <div className="modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" data-testid="consultation-modal">
        <button className="modal-close" onClick={onClose} data-testid="modal-close-button"><X size={20} /></button>
        <p className="eyebrow">{lang === "en" ? "START A CONVERSATION" : "MULAI PERCAKAPAN"}</p>
        <h2>{lang === "en" ? <>Let’s talk about<br /><em>your estate.</em></> : <>Mari berbicara tentang<br /><em>properti Anda.</em></>}</h2>
        <form onSubmit={submit} data-testid="consultation-form">
          <input placeholder={lang === "en" ? "Your name" : "Nama Anda"} required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name-input" />
          <input type="email" placeholder={lang === "en" ? "Email address" : "Alamat email"} required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email-input" />
          <input placeholder={lang === "en" ? "Villa location" : "Lokasi villa"} required value={form.villa_location} onChange={(e) => setForm({ ...form, villa_location: e.target.value })} data-testid="contact-location-input" />
          <button className="button button-dark" type="submit" disabled={sending} data-testid="contact-submit-button">
            {sending ? (lang === "en" ? "Sending…" : "Mengirim…") : ctaLabel} <ArrowUpRight size={16} />
          </button>
        </form>
        <p className="modal-note">{lang === "en" ? "We usually reply within one business day." : "Kami biasanya membalas dalam satu hari kerja."}</p>
      </div>
    </div>
  );
};
